import React from "react";
import {
  AccountCircleFilledIcon,
  AppleIcon,
  ArrowDropDownFilledIcon,
  ArrowDropUpFilledIcon,
  AudienceFilledIcon,
  BeachAccessFilledIcon,
  BluetoothFilledIcon,
  CachedFilledIcon,
  Campaign1Icon,
  CampaignFilledIcon,
  CancelFillIcon,
  CheckboxCheckedIcon,
  CheckBoxFilledIcon,
  CheckBoxOutlineBlankIcon,
  CheckCircleIcon,
  CircleIcon,
  CloudFilledIcon,
  CollaboratorsIcon,
  CollectionsFilledIcon,
  ContentCopyFilledIcon,
  ContentCutFilledIcon,
  ContentPasteOutlinedIcon,
  CopyIcon,
  CreditCardFilledIcon,
  DashboardFilledIcon,
  DateRange3FilledIcon,
  DateRangeFilledIcon,
  Deals1Icon,
  DeleteFilledIcon,
  Download2Icon,
  DraftsFilledIcon,
  EditFilledIcon,
  ErrorFilledIcon,
  ErrorOutlineIcon,
  FavoriteFilledIcon,
  Filter2ListFilledIcon,
  FilterAltFilledIcon,
  FilterListFilledIcon,
  FolderFilledIcon,
  FormatAlignLeftFilledIcon,
  FormEntries1Icon,
  GroupIcon,
  HeartFilledIcon,
  HomeFilledIcon,
  InboxFilledIcon,
  IncomingSmsIcon,
  IndeterminateCheckBoxFilledIcon,
  IndeterminateIcon,
  InfoFilledIcon,
  IphoneFilledIcon,
  LaughFillEmojiIcon,
  LayersFilledIcon,
  LockFilledIcon,
  MailFilledIcon,
  MailOutlineFilledIcon,
  MenuFilledIcon,
  MonitorFilledIcon,
  MoreHorizontalIcon,
  MoreVerticalIcon,
  MoveIcon,
  NextIcon,
  NotificationFilledIcon,
  OpenInNewFilledIcon,
  PaintBrushIcon,
  PauseIcon,
  PeopleFilledIcon,
  PersonAddFilledIcon,
  PersonFilledIcon,
  PhotoFilledIcon,
  PhotoOutlinedIcon,
  PlanFilledIcon,
  PlayArrowFilledIcon,
  PlayCircleOutlineFilled2Icon,
  PlayCircleOutlineFilledIcon,
  PlayIcon,
  RadioButtonCheckedFilledIcon,
  RadioButtonUncheckedFilledIcon,
  ReceiptFilledIcon,
  RemoveFilledIcon,
  RemoveRedEyeFilledIcon,
  SearchFilledIcon,
  SendFilledIcon,
  SendIcon,
  ServicesFilledIcon,
  SettingFilledIcon,
  SettingsFilledIcon,
  ShoppingCartFilledIcon,
  SkipNextFilledIcon,
  SkipPreviousFilledIcon,
  SocialIcon,
  SpaceDashboardFilledIcon,
  SpaceDashboardOutlinedIcon,
  StarFilledIcon,
  StarHalfFilledIcon,
  StarOutlineFilledIcon,
  StartRecordingIcon,
  StopIcon,
  StopRecordingIcon,
  SwapHorizOutlinedIcon,
  TableRowsFilledIcon,
  TasksIcon,
  TitleOutlinedIcon,
  UploadFileFilledIcon,
  UploadIcon,
  ViewColumnFilledIcon,
  ViewHeadlineFilledIcon,
  ViewModuleIcon,
  ViewStreamFilledIcon,
  VolumeIcon,
  WarningAmberOutlinedIcon,
  WarningFilledIcon,
  WebsiteFilledIcon,
  WifiFilledIcon,
  WorkFilled2Icon,
} from "convertupleads-theme";
import IconTitle from "./IconTitle";
import { IconsWrapper } from "./OutlinedIcons";

const FilledIcons = () => {
  return (
    <IconsWrapper>
      <IconTitle icon={<StartRecordingIcon />} title={"StartRecordingIcon"} />
      <IconTitle icon={<StopRecordingIcon />} title={"StopRecordingIcon"} />
      <IconTitle icon={<CollaboratorsIcon />} title={"CollaboratorsIcon"} />
      <IconTitle icon={<Deals1Icon />} title={"Deals1Icon"} />
      <IconTitle icon={<TasksIcon />} title={"TasksIcon"} />
      <IconTitle icon={<Campaign1Icon />} title={"Campaign1Icon"} />
      <IconTitle icon={<FormEntries1Icon />} title={"FormEntries1Icon"} />
      <IconTitle icon={<UploadIcon />} title={"UploadIcon"} />
      <IconTitle icon={<CheckboxCheckedIcon />} title={"CheckboxCheckedIcon"} />
      <IconTitle icon={<CopyIcon />} title={"CopyIcon"} />
      <IconTitle icon={<CheckCircleIcon />} title={"CheckCircleIcon"} />
      <IconTitle icon={<PlayIcon />} title={"PlayIcon"} />
      <IconTitle icon={<VolumeIcon />} title={"VolumeIcon"} />
      <IconTitle icon={<SendIcon />} title={"SendIcon"} />
      <IconTitle icon={<HeartFilledIcon />} title={"HeartFilledIcon"} />
      <IconTitle icon={<StarFilledIcon />} title={"StarFilledIcon"} />
      <IconTitle icon={<LaughFillEmojiIcon />} title={"LaughFillEmojiIcon"} />
      <IconTitle icon={<NextIcon />} title={"NextIcon"} />
      <IconTitle icon={<SocialIcon />} title={"SocialIcon"} />
      <IconTitle icon={<SettingsFilledIcon />} title={"SettingsFilledIcon"} />
      <IconTitle icon={<AudienceFilledIcon />} title={"AudienceFilledIcon"} />
      <IconTitle icon={<WebsiteFilledIcon />} title={"WebsiteFilledIcon"} />
      <IconTitle icon={<DashboardFilledIcon />} title={"DashboardFilledIcon"} />
      <IconTitle
        icon={<NotificationFilledIcon />}
        title={"NotificationFilledIcon"}
      />
      <IconTitle icon={<PlanFilledIcon />} title={"PlanFilledIcon"} />
      <IconTitle icon={<CampaignFilledIcon />} title={"CampaignFilledIcon"} />
      <IconTitle icon={<ServicesFilledIcon />} title={"ServicesFilledIcon"} />
      <IconTitle icon={<MoreHorizontalIcon />} title={"MoreHorizontalIcon"} />
      <IconTitle icon={<MoreVerticalIcon />} title={"MoreVerticalIcon"} />
      <IconTitle icon={<IndeterminateIcon />} title={"IndeterminateIcon"} />
      <IconTitle icon={<PauseIcon />} title={"PauseIcon"} />
      <IconTitle icon={<StopIcon />} title={"StopIcon"} />
      <IconTitle icon={<CircleIcon />} title={"CircleIcon"} />
      <IconTitle icon={<PaintBrushIcon />} title={"PaintBrushIcon"} />
      <IconTitle icon={<IncomingSmsIcon />} title={"IncomingSmsIcon"} />
      <IconTitle icon={<AppleIcon />} title={"AppleIcon"} />
      <IconTitle
        icon={<RemoveRedEyeFilledIcon />}
        title={"RemoveRedEyeFilledIcon"}
      />
      <IconTitle icon={<FavoriteFilledIcon />} title={"FavoriteFilledIcon"} />
      <IconTitle icon={<EditFilledIcon />} title={"EditFilledIcon"} />
      <IconTitle icon={<CancelFillIcon />} title={"CancelFillIcon"} />
      <IconTitle icon={<CachedFilledIcon />} title={"CachedFilledIcon"} />
      <IconTitle icon={<CheckBoxFilledIcon />} title={"CheckBoxFilledIcon"} />
      <IconTitle icon={<DateRangeFilledIcon />} title={"DateRangeFilledIcon"} />
      <IconTitle icon={<StarHalfFilledIcon />} title={"StarHalfFilledIcon"} />
      <IconTitle icon={<PhotoFilledIcon />} title={"PhotoFilledIcon"} />
      <IconTitle
        icon={<ShoppingCartFilledIcon />}
        title={"ShoppingCartFilledIcon"}
      />
      <IconTitle
        icon={<WarningAmberOutlinedIcon />}
        title={"WarningAmberOutlinedIcon"}
      />
      <IconTitle icon={<CloudFilledIcon />} title={"CloudFilledIcon"} />
      <IconTitle
        icon={<ContentCutFilledIcon />}
        title={"ContentCutFilledIcon"}
      />
      <IconTitle icon={<BluetoothFilledIcon />} title={"BluetoothFilledIcon"} />
      <IconTitle icon={<SendFilledIcon />} title={"SendFilledIcon"} />
      <IconTitle
        icon={<BeachAccessFilledIcon />}
        title={"BeachAccessFilledIcon"}
      />
      <IconTitle
        icon={<PlayCircleOutlineFilledIcon />}
        title={"PlayCircleOutlineFilledIcon"}
      />
      <IconTitle icon={<MonitorFilledIcon />} title={"MonitorFilledIcon"} />
      <IconTitle icon={<HomeFilledIcon />} title={"HomeFilledIcon"} />
      <IconTitle icon={<IphoneFilledIcon />} title={"IphoneFilledIcon"} />
      <IconTitle icon={<GroupIcon />} title={"GroupIcon"} />
      <IconTitle icon={<WifiFilledIcon />} title={"WifiFilledIcon"} />
      <IconTitle icon={<MoveIcon />} title={"MoveIcon"} />
      <IconTitle icon={<TitleOutlinedIcon />} title={"TitleOutlinedIcon"} />
      <IconTitle
        icon={<CollectionsFilledIcon />}
        title={"CollectionsFilledIcon"}
      />
      <IconTitle icon={<Download2Icon />} title={"Download2Icon"} />
      <IconTitle icon={<SearchFilledIcon />} title={"SearchFilledIcon"} />
      <IconTitle
        icon={<SpaceDashboardOutlinedIcon />}
        title={"SpaceDashboardOutlinedIcon"}
      />
      <IconTitle
        icon={<SpaceDashboardFilledIcon />}
        title={"SpaceDashboardFilledIcon"}
      />
      <IconTitle icon={<ViewModuleIcon />} title={"ViewModuleIcon"} />
      <IconTitle icon={<DraftsFilledIcon />} title={"DraftsFilledIcon"} />
      <IconTitle icon={<WorkFilled2Icon />} title={"WorkFilled2Icon"} />
      <IconTitle
        icon={<ArrowDropDownFilledIcon />}
        title={"ArrowDropDownFilledIcon"}
      />
      <IconTitle
        icon={<ArrowDropUpFilledIcon />}
        title={"ArrowDropUpFilledIcon"}
      />
      <IconTitle icon={<MenuFilledIcon />} title={"MenuFilledIcon"} />
      <IconTitle icon={<PersonFilledIcon />} title={"PersonFilledIcon"} />
      <IconTitle icon={<PersonAddFilledIcon />} title={"PersonAddFilledIcon"} />
      <IconTitle icon={<PeopleFilledIcon />} title={"PeopleFilledIcon"} />
      <IconTitle
        icon={<CheckBoxOutlineBlankIcon />}
        title={"CheckBoxOutlineBlankIcon"}
      />
      <IconTitle
        icon={<StarOutlineFilledIcon />}
        title={"StarOutlineFilledIcon"}
      />
      <IconTitle
        icon={<IndeterminateCheckBoxFilledIcon />}
        title={"IndeterminateCheckBoxFilledIcon"}
      />
      <IconTitle
        icon={<DateRange3FilledIcon />}
        title={"DateRange3FilledIcon"}
      />
      <IconTitle
        icon={<RadioButtonCheckedFilledIcon />}
        title={"RadioButtonCheckedFilledIcon"}
      />
      <IconTitle
        icon={<RadioButtonUncheckedFilledIcon />}
        title={"RadioButtonUncheckedFilledIcon"}
      />
      <IconTitle icon={<ReceiptFilledIcon />} title={"ReceiptFilledIcon"} />
      <IconTitle icon={<SettingFilledIcon />} title={"SettingFilledIcon"} />
      <IconTitle icon={<FolderFilledIcon />} title={"FolderFilledIcon"} />
      <IconTitle
        icon={<FormatAlignLeftFilledIcon />}
        title={"FormatAlignLeftFilledIcon"}
      />
      <IconTitle icon={<PhotoOutlinedIcon />} title={"PhotoOutlinedIcon"} />
      <IconTitle
        icon={<AccountCircleFilledIcon />}
        title={"AccountCircleFilledIcon"}
      />
      <IconTitle icon={<ErrorFilledIcon />} title={"ErrorFilledIcon"} />
      <IconTitle icon={<WarningFilledIcon />} title={"WarningFilledIcon"} />
      <IconTitle icon={<ErrorOutlineIcon />} title={"ErrorOutlineIcon"} />
      <IconTitle icon={<PlayArrowFilledIcon />} title={"PlayArrowFilledIcon"} />
      <IconTitle
        icon={<SkipPreviousFilledIcon />}
        title={"SkipPreviousFilledIcon"}
      />
      <IconTitle
        icon={<ContentPasteOutlinedIcon />}
        title={"ContentPasteOutlinedIcon"}
      />
      <IconTitle
        icon={<ContentCopyFilledIcon />}
        title={"ContentCopyFilledIcon"}
      />
      <IconTitle icon={<MailFilledIcon />} title={"MailFilledIcon"} />
      <IconTitle
        icon={<CreditCardFilledIcon />}
        title={"CreditCardFilledIcon"}
      />
      <IconTitle icon={<SkipNextFilledIcon />} title={"SkipNextFilledIcon"} />
      <IconTitle
        icon={<Filter2ListFilledIcon />}
        title={"Filter2ListFilledIcon"}
      />
      <IconTitle
        icon={<MailOutlineFilledIcon />}
        title={"MailOutlineFilledIcon"}
      />
      <IconTitle
        icon={<PlayCircleOutlineFilled2Icon />}
        title={"PlayCircleOutlineFilled2Icon"}
      />
      <IconTitle
        icon={<ViewHeadlineFilledIcon />}
        title={"ViewHeadlineFilledIcon"}
      />
      <IconTitle icon={<LockFilledIcon />} title={"LockFilledIcon"} />
      <IconTitle icon={<LayersFilledIcon />} title={"LayersFilledIcon"} />
      <IconTitle icon={<InboxFilledIcon />} title={"InboxFilledIcon"} />
      <IconTitle icon={<OpenInNewFilledIcon />} title={"OpenInNewFilledIcon"} />
      <IconTitle
        icon={<UploadFileFilledIcon />}
        title={"UploadFileFilledIcon"}
      />
      <IconTitle icon={<DeleteFilledIcon />} title={"DeleteFilledIcon"} />
      <IconTitle
        icon={<SwapHorizOutlinedIcon />}
        title={"SwapHorizOutlinedIcon"}
      />
      <IconTitle
        icon={<ViewColumnFilledIcon />}
        title={"ViewColumnFilledIcon"}
      />
      <IconTitle icon={<TableRowsFilledIcon />} title={"TableRowsFilledIcon"} />
      <IconTitle
        icon={<ViewStreamFilledIcon />}
        title={"ViewStreamFilledIcon"}
      />
      <IconTitle icon={<FilterAltFilledIcon />} title={"FilterAltFilledIcon"} />
      <IconTitle icon={<RemoveFilledIcon />} title={"RemoveFilledIcon"} />
      <IconTitle icon={<InfoFilledIcon />} title={"InfoFilledIcon"} />
      <IconTitle
        icon={<FilterListFilledIcon />}
        title={"FilterListFilledIcon"}
      />
    </IconsWrapper>
  );
};

export default FilledIcons;
